// import { Moon, Sun } from "lucide-react"
//
// import { Button } from "@/components/ui/button"
// import { useTheme } from "@/hooks/use-theme"
//
// export function ThemeToggle() {
//   const { theme, setTheme } = useTheme()
//
//   const toggleTheme = () => {
//     if (theme === "light") {
//       setTheme("dark")
//     } else if (theme === "dark") {
//       setTheme("light")
//     } else {
//       setTheme("light")
//     }
//   }
//
//   return (
//     <Button 
//       variant="outline" 
//       size="icon" 
//       onClick={toggleTheme}
//       className="w-[50px] h-[50px]"
//     >
//       <Sun className="h-[1.2rem] w-[1.2rem] rotate-0 scale-100 transition-all dark:-rotate-90 dark:scale-0" />
//       <Moon className="absolute h-[1.2rem] w-[1.2rem] rotate-90 scale-0 transition-all dark:rotate-0 dark:scale-100" />
//       <span className="sr-only">Change Theme</span>
//     </Button>
//   )
// }

// Sadece dark mode aktif, toggle kaldırıldı.
export function ThemeToggle() {
  return null;
}